export default __webpack_public_path__ + "static/media/UserGuide_ru_RU.1cf86647.pdf";